import React from "react";
import { Scrollbars } from "components/Scrollbars";
import { useTranslation } from "react-i18next";
import { UserNotificationResponse } from "./NotificationBell";
import { NotificationListItem } from "./NotificationListItem";
import spinnerSvg from "../../../assets/svg/spinner-white.svg";
import { useDeleteNotification } from "hooks/useDeleteNotification";
import { useAppSelector } from "store/hooks";

type Props = {
  notifications: UserNotificationResponse[];
};

export const NotificationBellPopover: React.FC<Props> = ({ notifications }) => {
  const { t } = useTranslation();
  const language = t("localization_testing");
  const navigationIsDisabled = useAppSelector(
    (state) => state.meals.navigationIsDisabled
  );
  console.log("this is notifications", notifications);
  const { mutate: deleteNotification, isLoading: deleteNotificationIsLoading } =
    useDeleteNotification();
  return (
    <div
      className={`lg:items-start z-50 mr-6 text-slate-200 bg-slate-800 border border-slate-50 rounded-md w-64 md:w-80 h-64`}
    >
      {(notifications?.length === 0 || !notifications) &&
        !deleteNotificationIsLoading && (
          <p className="text-center pt-4 text-sm 2xl:text-base mx-4 text-slate-300">
            {t("user.noNotifications")}
          </p>
        )}
      {deleteNotificationIsLoading && (
        <div className="w-full h-full flex justify-center items-center">
          <img className="h-6 animate-spin" src={spinnerSvg} alt="loading" />
        </div>
      )}
      {notifications?.length > 0 && !deleteNotificationIsLoading && (
        <div className="h-52">
          <h1 className="pl-1 text-slate-300 text-sm">
            {t("user.clickToMarkAsRead")}
          </h1>
          <Scrollbars>
            <ul className="pr-2 pl-1 py-1 ">
              {notifications?.map((notification: UserNotificationResponse) => {
                return (
                  <NotificationListItem
                    read={notification?.read}
                    key={notification?.id}
                    id={notification?.id}
                    label={
                      language === "fr"
                        ? notification?.labels.fr
                        : notification?.labels.en
                    }
                  />
                );
              })}
            </ul>
          </Scrollbars>
          <div className="">
            {!deleteNotificationIsLoading && (
              <button
                disabled={deleteNotificationIsLoading || navigationIsDisabled}
                type="button"
                onClick={() => deleteNotification("clear")}
                className=" pl-1 rounded-br-md text-slate-300 text-sm hover:text-white"
              >
                {t("form.clearAll")}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
